import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";
import GDDateRangePicker from '../../gd-components/datetime/gd-daterange-picker/daterange-picker';
import Classes from 'classnames';

export default class SelectStartEnd extends BaseComponent {

    static propTypes = {
        value: PropTypes.object,        // current date range value moment object

        dateRangePresets: PropTypes.array,
        dateFormat: PropTypes.string,
        renderValue: PropTypes.oneOf(['inline', 'text-14', 'text-normal', 'text-13', 'text-12', 'text-11','inline-icon','form-default']),
        type: PropTypes.oneOf(['default','form','inline','list']),
        size: PropTypes.string, // small, normal, big

        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        minDaysRange: PropTypes.number,

        btnNoValue: PropTypes.bool,
        btnNoValueLabel: PropTypes.string,

        placeholder: PropTypes.string,
        hint: PropTypes.string,
        underlined: PropTypes.oneOf(['on-hover', 'always', 'never']),

        popoverAttachment: PropTypes.string,
        popoverTargetAttachment: PropTypes.string,
        popoverTargetOffset: PropTypes.string,
        attachmentType: PropTypes.string,
        tetherConstraints: PropTypes.array,

        onTogglePopover: PropTypes.func,
        onChange: PropTypes.func,      // on change callback
        disabled: PropTypes.bool,

        // form - if passed component will act as form element
        form: PropTypes.object,
        startName: PropTypes.string,
        endName: PropTypes.string,

        deleteButton: PropTypes.bool        // if true will show delte button to reset date to null
    };

    static defaultProps = {
        type: 'default',
        deleteButton: false,
        placeholder: 'Start/End'
    };

    constructor(props) {
        super(props);
        const { value, form, startName, endName } = props;

        this.state = {
            start: form ? form.getValue(startName) : value ? value.start : null,
            end: form ? form.getValue(endName) : value ? value.end : null,
        };

        this._bind('onChange', 'onDeleteClick');
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        const { value, form, startName, endName} = nextProps;

        // when form value changed and we re-render the whole thing
        this.setState({
            start: form ? form.getValue(startName) : value ? value.start : null,
            end: form ? form.getValue(endName) : value ? value.end : null,
        });
    }

    UNSAFE_componentWillMount() {
        if (this.props.form) this.props.form.registerFormComponent(this.props.startName, this);
    }

    setValue = (dateRange) => {
        this.setState({
            start: dateRange.start,
            end: dateRange.end
        });
    };

    //for reference call from outside
    onClick = () => {
        if(this.props.disabled) return;

        this.gdDateRangePicker.togglePopover();
    };

    onChange(dateRange){
        if (dateRange && this.props.minDaysRange) {
            const daysInRange = dateRange.end.diff(dateRange.start, 'days') + 1;
            if (daysInRange < this.props.minDaysRange) {
                dateRange = Moment.range(
                    Moment(dateRange.start),
                    Moment(dateRange.start).add(this.props.minDaysRange, 'days')
                );
            }
        }

        this.setState({
            start: dateRange ? dateRange.start : null,
            end: dateRange ? dateRange.end : null
        }, ()=>{
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.startName, dateRange ? dateRange.start.format("YYYY-MM-DD") : null);
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.endName, dateRange ? dateRange.end.format("YYYY-MM-DD") : null);
            if (this.props.onChange) this.props.onChange(dateRange);
        });
    }

    onDeleteClick(e) {
        if (e) e.stopPropagation();
        this.onChange(null);
    }

    render() {
        const empty = !this.state.start || !this.state.end;
        const classes = Classes('gd-select-start-end', 'render-'+this.props.renderValue, this.props.type+'-type', this.props.className, {
            'with-delete-button': this.props.deleteButton,
            disabled: this.props.disabled,
            empty: empty
        });

        const value = this.state.start && this.state.end ? Moment.range(Moment(this.state.start), Moment(this.state.end)) : null;

        const dateFormat = this.props.dateFormat ? this.props.dateFormat : gd.session.me.formatSettings.date;

        return (
            <div className={classes} onClick={this.onClick}>
                <GDDateRangePicker ref={r=>this.gdDateRangePicker = r}
                                   type={this.props.renderValue}
                                   size={this.props.size}
                                   disabled={this.props.disabled}
                                   underlined={this.props.underlined}
                                   placeholder={this.props.placeholder}
                                   popoverTargetAttachment={this.props.popoverTargetAttachment}
                                   popoverAttachment={this.props.popoverAttachment}
                                   popoverTargetOffset={this.props.popoverTargetOffset}
                                   tetherConstraints={this.props.tetherConstraints}
                                   attachmentType={this.props.attachmentType}
                                   presets={this.props.dateRangePresets}
                                   dateFormat={dateFormat}
                                   noIcon={this.props.renderValue !== 'inline'}
                                   value={value}
                                   minDate={this.props.minDate}
                                   maxDate={this.props.maxDate}
                                   btnNoValue={this.props.btnNoValue}
                                   btnNoValueLabel={this.props.btnNoValueLabel}
                                   hint={this.props.hint}
                                   onUserSelect={this.onChange}
                                   onTogglePopover={this.props.onTogglePopover}/>

                {this.props.deleteButton && !this.props.disabled && !empty &&
                    <div className="reset-button" onClick={this.onDeleteClick}>
                        <div className="reset-icon ui5-ico-delete s14 gray"/>
                    </div>}
            </div>
        );
    }
}
